import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from "./store/index.js";
import * as multilingual from './i18n/index';

// 引入并使用element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

// 复制内容
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 提示js方法
import popup from "@/assets/js/popup.js";
popup(Vue.prototype);

// js生成css（padding和margin）
import css from '@/assets/js/css.js';
css();

// 开发模式,true运行console.log，false不运行
let debug = false;
Vue.prototype.$debug = debug;

// 词条替换
Vue.prototype.$getCharacters = languageRoute => {
	let language = store.state.language;
	let routeList = languageRoute.split('.');
	let msg = multilingual.default[language];
	routeList.forEach(item => {
		msg = msg[item];
	})
	return msg;
}

// 窗口高度
var clientHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
var winWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth);
Vue.prototype.$winWidth = winWidth;
Vue.prototype.$winHeight = clientHeight;

// 获取元素是否处于可视区域
Vue.prototype.$getTop = (id) => {
	let el = document.getElementById(id);
	if (!el) return store.state.scroll_height
	// 滚动距离 > 元素位置，离场；
	// 滚动距离 > 元素位置 - 窗口高度时，进场；
	// 元素位置 > 窗口高度 + 滚动距离，未进场；
	if (store.state.scroll_height > el.offsetTop + clientHeight / 4) {
		// console.log('离场')
	} else if (store.state.scroll_height > el.offsetTop - clientHeight + 200 && store.state.scroll_height < el
		.offsetTop +
		clientHeight - 200) {
		// console.log('进场');
		return true
	} else {
		// console.log('未进场')
	}
	return false;
}

// 获取元素距离页面顶部的距离
// 页面滚动到目标位置,传入scroll则滚动到该位置；传入id则先获取该元素所在的位置再滚动到该位置；
Vue.prototype.scroll = ({
	scroll,
	id
}) => {
	scroll = Number(scroll || 0);
	if (id) {
		let el = document.getElementById(id);
		if (!el) return
		debug && console.log('目标元素', id, '目标位置', el.offsetTop);
		scroll = el.offsetTop;
	}

	scroll -= store.state.headBarHeight; //减去头部栏高度，是最终的目标位置
	debug && console.log('目标位置', scroll)
	let location = window.scrollY; //滚动条当前位置
	debug && console.log('当前位置', location)
	let distance = scroll - location; //当前目标位置减去当前位置得到距离，可正可负
	debug && console.log('距离', distance);
	let step = distance / 30; //距离除以步数得到步长，每次滚动耗时等于30*10 = 300毫秒
	debug && console.log('步长', step);
	let tiemr = setInterval(() => {
		location += step; //当前位置加步长，更新当前位置
		if (distance > 0 && location >= scroll || distance < 0 && location <= scroll) { //当前位置大于目标位置时停止滚动
			clearInterval(tiemr);
			location = scroll;
		}
		debug && console.log('当前滚动位置', location)
		window.scrollTo(0, location);
	}, 10);
	// 防止滚动不到位产生不可控现象，增加到时清除定时器；
	setTimeout(() => {
		clearInterval(tiemr);
	}, 300)
}

// 代理
import axios from 'axios';
/*
this.$get({
	url:'',
	loading:'加载中',
	hint:'成功',
	success:res=>{

	},
	complete:res=>{

	}
})
*/
 let host ='https://officialservices.lango-tech.com/'
 //let host ='http://192.168.13.156/'
// 'https://lango.runmou.net/';
//'http://lango.runmou.net:8080/js/'; //http://mockjs.docway.net/mock/1cxV4qzQiHp/', //请求头地址

// let imgUrl = 'http://officialservices.lango-tech.com/'
// let imgUrl = 'http://192.168.20.104/'
Vue.prototype.$host = host;
Vue.prototype.$imgUrl = host
let $req = (params) => {
	// 显示加载中
	if (params.loading) {
		store.commit('setInfo', {
			type: "login_text",
			value: params.loading
		})
	}

	// 请求成功或失败都执行
	let down = (data) => {
		params.complete && params.complete(data);
		//成功后 隐藏加载中
		if (params.loading) {
			store.commit('setInfo', {
				type: "login_text",
				value: null
			})
		}
	}

	// 静态模拟请求
	// let timeout = setTimeout(() => {
	// 	clearTimeout(timeout);
	// 	down();
	// 	if (params.hint) {
	// 		Vue.prototype.$success(params.hint)
	// 	}
	// 	params.success && params.success([1, 1, 1, 1, 1, 1, 1, 1, 1, 1]);
	// }, 1000);
	// return

	// 发起请求
	if (store.state.language == 'EN') {
		params.data ? params.data.isFanyi = true : params.data = {
			isFanyi: true
		}
	}
	axios({
			url: params.url, //拼接请求地址
			method: params.method || 'get', //请求方法
			baseURL: host,
			headers: {
				"Content-Type": "application/x-www-form-urlencoded"
				// "Authorization": store.state.user_info.token || ''
			}, //请求头携带参数
			"params": params.data, //params传参
			data: params.data, //data传参
			timeout: 6000, //超时时间
		}).then(function(res) {
			down(res);
			// if (res.data.success) {
			if (typeof res.data.body.list == 'string') res.data.body.list = JSON.stringify(res.data.body.list)
			if (params.hint) Vue.prototype.$success(params.hint);
			params.success && params.success(res.data.body);
			// } else Vue.prototype.$warn(res.data.msg)
		})
		.catch(function(error) {
			down(error);
			// Vue.prototype.$warn(error)
			debug && console.log(params.url, '$post请求错误', error);
		});
}

Vue.prototype.$req = $req;
Vue.prototype.$get = (params) => {
	params.method = 'get';
  console.log(params)
	$req(params);
};
Vue.prototype.$post = (params) => {
	params.method = 'post';
	$req(params);
};
Vue.prototype.$put = (params) => {
	params.method = 'put';
	$req(params);
};
Vue.prototype.$del = (params) => {
	params.method = 'delete';
	$req(params);
};

// 获取用户信息
Vue.prototype.getUserInfo = (callback) => {
	$req({
		method: 'get',
		url: 'user/info',
		success: res => {
			callback && callback(res);
			store.commit('setInfo', {
				type: 'user_info',
				value: res
			})
		}
	});
};

// PropContent组件显示时，添加一个组件的引用，键盘按下esc键，隐藏组件；
let props = [];
Vue.prototype.$esc = (that) => {
	if (that) {
		props.push(that);
	} else {
		let prop = props.pop();
	}
}
document.addEventListener('keyup', e => {
	if (e.keyCode == 27) {
		let that = props[props.length - 1];
		if (that) that.show = false;
	}
});

// 公共组件
import components from "@/components/AComponents.js";
components(Vue);

// 页面滚动时调用，在components/headBar组件中；数组会在路由变化时清空
let scroll_list = [];

// 窗口滚动遍历数组，滚动到该元素时回调，然后删除该元素；
store.commit('setScrollHeight', document.documentElement.scrollTop || document.body.scrollTop);
window.onscroll = res => {
	var scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //滚动条位置
	let win_height = document.documentElement.clientHeight
	store.commit('setScrollHeight', scrollTop);
	scroll_list.map((v, i) => {
		if (scrollTop > v.scrollTop) {
			v.callback(true);
			scroll_list.splice(i, 1)
		}
		// if (scrollTop + win_height > v.scrollTop){
		// 	v.callback(false);
		// }
	})
};

// 清空滚动数组
// Vue.prototype.$clearScrollList = () => {
// 	scroll_list = [];
// 	debug && console.log('请空滚动数组')
// }
// Vue.prototype.$addScroll = (id, callback) => {
// debug && console.log('调用滚动元素监听', document.getElementById(id).offsetTop);
// 将元素位置和回调方法放入数组中
// scroll_list.push({
// callback,
// scrollTop: document.getElementById(id).offsetTop
// })
// }
// 获取全局菜单
Vue.prototype.$getMenu = new Promise((resolve, reject) => {
	let menu_list = [];
	Vue.prototype.$get({
		url: 'app/getTopMenus',
		success: res => {
			menu_list = res.list.map((v, i) => {
				v.childrenList = [];
				if(i == 2)v.url_name = 'AboutUs';
				else if(i == 3)v.url_name = 'DownLoad';
				else if(i == 4)v.url_name = 'JoinUs';
				else if(i == 5)v.url_name = 'Dynamic';
				else if(i == 0)v.url_name = 'ProductCenter';
				else if(i == 1)v.url_name = 'Solution';
				return v;
			});
			// 产品中心二级菜单
			Vue.prototype.$get({
				url: 'app/solution/getMenus',
				data: {
					type: 0
				},
				success: res => {
					menu_list[0].childrenList = res.list;
					// 解决方案二级菜单
					Vue.prototype.$get({
						url: 'app/solution/getMenus',
						data: {
							type: 1
						},
						success: res => {
							menu_list[1].childrenList = res.list;
							resolve(menu_list)
						}
					});
				}
			});
		}
	});
})

// 计算当前页面对应菜单
Vue.prototype.$filterMenu = (obj) => {
	Vue.prototype.$getMenu.then(list => {
		let menu = [...list[1].childrenList,...list[0].childrenList];
		for(let i in menu){
			let cMenu = menu[i].childrenList;
			for(let j in cMenu){
				if(cMenu[j].id == obj.id){
					obj.success(cMenu[j]);
					return
				}
			}
		}
		return
		for (let i in list) {
			let v = list[i];
			if (v.id == obj.id) {
				obj.success(v);
				return v;
			} else {
				for (let j in v.childrenList) {
					let val = v.childrenList[j];
					if (val.id == obj.id) {
						obj.success(val);
						return
					} else {
						for (let k in val.childrenList) {
							let value = val.childrenList[k];
							if (value.id == obj.id) {
								obj.success(value);
								return
							}
						}
					}
				}
			}
		}
	})
}

// 分页中每页的数量
Vue.prototype.$size = 2;
// 全局注入混入，计算属性计算用户信息
Vue.mixin({
	// 固定数值放data中
	data() {
		return {

		}
	},
	// 会变的放computed中
	computed: {

		// 返回当前路径
		path() {
			return this.$route.name
		},
		// 当前屏幕宽度
		win_size() {
			return this.$store.state.win_size;
		},
		// 屏幕尺寸小于1024显示手机样式,css/fs.css也需要修改
		is_phone() {
			return this.$store.state.win_size < 1024
		},
		// 当前屏幕滚动距离
		scroll_height() {
			return this.$store.state.scroll_height;
		},
		// 头部栏高度
		headBarHeight() {
			return this.$store.state.headBarHeight;
		},
		// // 当前路由
		// path() {
		// 	return this.$route.name;
		// },
		// 默认图片
		default_img() {
			return 'https://imgtest.togy.com.cn/oyjj/dxqc/icon/headimg.jpg';
		},
		// 用户信息
		user_info() {
			this.userInfoChange && this.userInfoChange(store.state.user_info);
			return store.state.user_info;
		},
		// 用户类型
		user_type() {
			return store.state.user_info.type;
		},
		// 全局配置信息
		config_info() {
			return store.state.config_info;
		}
	}
});

// 注册全局过滤器
Vue.filter('changeTime', function(time) {
	if (!time) return ''
	return new Date(time).toLocaleDateString();
});
/*
使用方法：
<!-- 在双花括号中 -->
{{ message | capitalize }}

<!-- 在 `v-bind` 中 -->
<div v-bind:id="rawId | formatId"></div>
*/

Vue.config.productionTip = false;


new Vue({
	store,
	router,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js